import { render, staticRenderFns } from "./YagiChatBotMessages.vue?vue&type=template&id=551c9d69&scoped=true"
import script from "./YagiChatBotMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiChatBotMessages.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiChatBotMessages.vue?vue&type=style&index=0&id=551c9d69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c9d69",
  null
  
)

export default component.exports